// =====================================================================
// Cooldown persistido em localStorage — usado nos fluxos que mandam email
// (esqueci senha, recuperar conta, reenviar confirmação) pra não deixar
// disparar de novo antes do tempo. Sobrevive a reload/nova aba.
// =====================================================================
import { useCallback, useEffect, useState } from 'react';

export function formatarCooldown(segundos) {
    const s = Math.max(0, Math.floor(segundos));
    const m = Math.floor(s / 60);
    const r = s % 60;
    return `${m}m ${String(r).padStart(2, '0')}s`;
}

export function useCooldown(storageKey, defaultMinutes = 10) {
    const readAlvo = useCallback(() => {
        try {
            const iso = localStorage.getItem(storageKey);
            if (!iso) return 0;
            const alvo = new Date(iso).getTime();
            return Number.isNaN(alvo) ? 0 : alvo;
        } catch {
            return 0;
        }
    }, [storageKey]);

    const [alvo, setAlvo] = useState(readAlvo);
    const [agora, setAgora] = useState(() => Date.now());

    useEffect(() => {
        if (!alvo || alvo <= Date.now()) return undefined;
        const id = setInterval(() => setAgora(Date.now()), 1000);
        return () => clearInterval(id);
    }, [alvo]);

    const secondsLeft = Math.max(0, Math.ceil((alvo - agora) / 1000));
    const isActive = secondsLeft > 0;

    const startAt = useCallback((iso) => {
        try {
            localStorage.setItem(storageKey, iso);
        } catch { /* sem storage — ignora */ }
        setAlvo(new Date(iso).getTime());
        setAgora(Date.now());
    }, [storageKey]);

    const start = useCallback((minutes = defaultMinutes) => {
        const iso = new Date(Date.now() + minutes * 60_000).toISOString();
        startAt(iso);
    }, [defaultMinutes, startAt]);

    return { isActive, secondsLeft, start, startAt };
}
